export function loadAcalogAPI(callback, reload = false) {
  const ID = "acalog-script";

  if (reload) {
    const existingScript = document.getElementById(ID);
    if (existingScript) {
      existingScript.parentNode.removeChild(existingScript);
    }
  }

  if (typeof window.AcalogWidgetAPI !== "undefined") {
    callback();
    return;
  }

  var script = document.createElement("script");
  script.src = "https://catalog.sunywcc.edu/widget-api/widget-api.min.js";
  script.id = ID;
  script.onload = callback;
  document.head.appendChild(script);
}